import { render, staticRenderFns } from "./block-push.vue?vue&type=template&id=2d44e25a&scoped=true&"
import script from "./block-push.vue?vue&type=script&lang=js&"
export * from "./block-push.vue?vue&type=script&lang=js&"
import style0 from "./block-push.vue?vue&type=style&index=0&id=2d44e25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44e25a",
  null
  
)

export default component.exports